import {CommonContractorCreateUpdateApp} from "../../../../Dashboard/Contractors/Functionality/ContractorCreateUpdateFlows/CommonContractorCreateUpdateApp";
import routes from "../../../../../Routes/routes";
import HeadTittle from "../../../../../components/HeadTittle";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import {EditIcon} from "../../../../../components/buttons/IconButtons";
import ManagerFields from "../../../../Dashboard/Contractors/SubComponents/ContractorCreateUpdateFlows/ManagerFields";
import React from "react";
import {SupplierFlowEmployeeUpdateApp} from "../../Funtionality/SupplierCreateUpdateFlows/SupplierFlowEmployeeUpdateApp";
import StepTab from '../../../../../components/StepperTabs/StepTab';
import CustomPhotoPicker from '../../../../../components/PhotoPicker/CustomPhotoPicker';
import {ACTION_MODEL} from '../../../../../Helpers/ActionModel';
import {FILE_TYPE} from '../../../../../Helpers/fileType';
import {SUGGESTION_MODE_OPTION} from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import StepperTabs from '../../../../../components/StepperTabs/StepperTabs';
import CopySecretModal from '../../../../Dashboard/Company/Employees/Modal/CopySecretModal';
import { TABS_SUPPLIER_EMPLOYEE} from '../../../../Dashboard/Company/Employees/Model/Models';
import { validateMinLengthTrimmed } from "../../../../../Apis/functions";
import { PASSWORD_MIN_LENGTH } from "../../../../../constant/variable";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const SupplierFlowEmployeeUpdate = () => {

    const props = CommonContractorCreateUpdateApp();

    const {
        t,
        supplierId,
        params,
        permission,
        dispatch,
        setEmptyFields,
        isValidEmail,
        isValidPhoneNumber,
        isValidDob,
        setIsValidDob,
        isValidDocumentId,
        setIsValidDocumentId,
        userInfoStatusList,
        secretModal, setSecretModal,
        secretKey, setSecretKey,
        photoPicker,
        setPhotoPicker,
        handleDateChange,
        handleEmailChange,
        handlePhoneNumberChange,
        validateEmail,
        validatePhone,
        isValidPassword,
        setIsValidPassword,
        handlePasswordChange
    }  = props;

    const {
        emptyFields,
        user,
        setUser,
        FormHandler,
        steps,
        activeStep, setActiveStep,
        handleStepChange
    } = SupplierFlowEmployeeUpdateApp({
        t,
        permission,
        dispatch,
        setEmptyFields,
        isValidEmail,
        isValidPhoneNumber,
        isValidPassword,
        isValidDob,
        supplierId,
        params,
        photoPicker,
        setPhotoPicker,
        setSecretModal,
        setSecretKey
    });

    return (
        <>
            <HeadTittle
                link={routes.suppliers.employees}
                name={t("update")}
            >
                <ButtonAction
                    id={'btn_sfeu_create'}
                    name={'update'}
                    className={'btn-icon-edit'}
                    disabled={false}
                    Icon={EditIcon}
                    onClick={() => {
                        validateEmail(user.email);
                        validatePhone(user.phoneNumber);
                        const isValid = validateMinLengthTrimmed(user.password, {
                                minLength: PASSWORD_MIN_LENGTH,
                                allowEmpty: true,
                            });
                            setIsValidPassword(isValid);

                            if (!isValid) return;
                        FormHandler();
                    }}
                />
            </HeadTittle>

            <StepperTabs
                id={user?.id} steps={steps} activeStep={activeStep}
                isStepOptional={() => { }} setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={TABS_SUPPLIER_EMPLOYEE.DETAILS.INDEX} activeStep={activeStep} normalHeight={true}>
                    <ManagerFields
                        title={"user_data"}
                        user={user}
                        setUser={setUser}
                        emptyFields={emptyFields}
                        isValidDocumentId={isValidDocumentId}
                        setIsValidDocumentId={setIsValidDocumentId}
                        isValidEmail={isValidEmail}
                        isValidPhoneNumber={isValidPhoneNumber}
                        isValidDob={isValidDob}
                        setIsValidDob={setIsValidDob}
                        handleEmailChange={handleEmailChange}
                        handlePhoneNumberChange={handlePhoneNumberChange}
                        handleDateChange={handleDateChange}
                        statusList={userInfoStatusList}
                         handlePasswordChange={handlePasswordChange}
                    />
                </StepTab>
                <StepTab index={TABS_SUPPLIER_EMPLOYEE.PHOTO.INDEX} activeStep={activeStep} normalHeight={true}>
                    <CustomPhotoPicker
                        id='fp_sfeu_update_photo_profile'
                        photoPicker={photoPicker}
                        setPhotoPicker={setPhotoPicker}
                        actionModel={ACTION_MODEL.UPDATE}
                        accept={{ ...FILE_TYPE.IMAGE_FACE_VALIDATION }}
                        showBtnCamera={true}
                        validateFace={true}
                        classWith={'w-400px'}
                        showPreview={true}
                        titleModalEdit='update_photography'
                        typeSuggestions={SUGGESTION_MODE_OPTION.SELFIE} // It is required if showBtnCamera is true
                    />
                </StepTab>
            </StepperTabs>

            <CopySecretModal
                show={secretModal}
                setShow={setSecretModal}
                secret={secretKey}
                setSecret={setSecretKey}
                setData={setUser}
                onHide={() => {}}
                closeText={"close"}
            />

        </>
    );
};
export default SupplierFlowEmployeeUpdate
